import { SearchResult, SearchSectionId } from '../types';
import { getMatchFunction, calculateRelevanceScore } from '../utils';

/**
 * Search Einstellungen (Settings)
 * Returns static navigation items for settings pages
 */
export async function searchEinstellungen(
  term: string, 
  limit: number, 
  exactMatch: boolean,
  fuzzyMatch: boolean = false,
  signal?: AbortSignal
): Promise<SearchResult[]> {
  if (!term.trim()) return [];
  
  const matchFn = getMatchFunction(exactMatch, fuzzyMatch);
  
  // Static settings entries
  const einstellungen = [
    { id: 'profil', title: 'Profil', subtitle: 'Persönliche Einstellungen' },
    { id: 'benachrichtigungen', title: 'Benachrichtigungen', subtitle: 'E-Mail und Push-Einstellungen' },
    { id: 'sicherheit', title: 'Sicherheit', subtitle: 'Passwort und 2FA' },
    { id: 'darstellung', title: 'Darstellung', subtitle: 'Theme und Layout' },
    { id: 'module', title: 'Module & Abos', subtitle: 'Modulverwaltung' },
    { id: 'integration', title: 'Integrationen', subtitle: 'API und externe Dienste' },
  ];
  
  return einstellungen
    .filter(e => matchFn(term, e.title, e.subtitle))
    .slice(0, limit)
    .map(e => ({
      id: e.id,
      type: 'einstellungen' as SearchSectionId,
      title: e.title,
      subtitle: e.subtitle,
      badge: 'Einstellung',
      data: e,
      relevanceScore: calculateRelevanceScore(term, e.title, e.subtitle)
    }));
}
